import { createReducer, on } from "@ngrx/store";
import * as Actions from "./calendar-integration.actions";
import type { CalendarIntegrationState } from "./calendar-integration.models";

export const initialState: CalendarIntegrationState = {
  integrations: [],
  loading: false,
  error: null,
};

export const calendarIntegrationReducer = createReducer(
  initialState,

  on(Actions.CalendarIntegrationFetchRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(Actions.CalendarIntegrationFetchSuccess, (state, { integrations }) => ({
    ...state,
    integrations,
    loading: false,
    error: null,
  })),

  on(Actions.CalendarIntegrationFetchFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(Actions.CalendarIntegrationUpsertSuccess, (state, { integration }) => ({
    ...state,
    integrations: [integration, ...state.integrations.filter((item) => item.provider !== integration.provider)],
  })),

  on(Actions.CalendarIntegrationDisconnectSuccess, (state, { provider }) => ({
    ...state,
    integrations: state.integrations.map((item) =>
      item.provider === provider ? { ...item, status: 'disconnected' } : item
    ),
  })),
);

